import React, { forwardRef } from "react";
import { MenuItem } from "@mui/material";
import { cssLengthToPx } from "@CubeComponents/utils/cssLengthToPx";

/**
 * MenuItemComponent
 * Unifies padding, height, font-size, and "inherit" font family.
 * For submenu anchors, ref is forwarded to MUI MenuItem.
 */
const MenuItemComponent = forwardRef(function MenuItemComponent(
  {
    children,
    onClick,
    disabled = false,
    title,
    width = "auto",
    height = "3rem",
    paddX = 16,
    paddY = 8,
    fontSize = "0.875rem",
    color = "#192048",
    sx = {},
    ...rest
  }: any,
  ref: any,
) {
  // Normalize numeric / "Npx" / "Nrem" inputs to a px number, then emit rem so the
  // sx string honors the user's root font-size scaling.
  const paddXpx = (() => {
    const v = cssLengthToPx(paddX);
    return Number.isFinite(v) ? v : 16;
  })();
  const paddYpx = (() => {
    const v = cssLengthToPx(paddY);
    return Number.isFinite(v) ? v : 8;
  })();

  return (
    <MenuItem
      ref={ref}
      disabled={disabled}
      onClick={onClick}
      title={title}
      sx={{
        height,
        px: `${paddXpx / 16}rem`,
        py: `${paddYpx / 16}rem`,
        fontSize,
        color,
        display: "flex",
        alignItems: "center",
        gap: "1rem",
        width,
        fontFamily: "inherit",
        borderTop: "0.0625rem solid #ECF3FE",
        ...sx,
      }}
      {...rest}
    >
      {children}
    </MenuItem>
  );
});

export default MenuItemComponent;
